var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrasaSubcutaneaImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12751",
    "data-name": "Group 12751",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.734,
    height: 18.84,
    viewBox: "0 0 22.734 18.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11549",
    "data-name": "Group 11549",
    transform: "translate(1.657 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11548",
    "data-name": "Group 11548",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7214",
    "data-name": "Path 7214",
    d: "M621.258,149.55a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,621.258,149.55Z",
    transform: "translate(-604.686 -148.126)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7215",
    "data-name": "Path 7215",
    d: "M524.947,149.55a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,524.947,149.55Z",
    transform: "translate(-511.689 -148.126)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7216",
    "data-name": "Path 7216",
    d: "M428.637,149.55a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,428.637,149.55Z",
    transform: "translate(-418.694 -148.126)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7217",
    "data-name": "Path 7217",
    d: "M332.326,149.55a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,332.326,149.55Z",
    transform: "translate(-325.697 -148.126)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7218",
    "data-name": "Path 7218",
    d: "M236.015,149.55a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,236.015,149.55Z",
    transform: "translate(-232.701 -148.126)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7219",
    "data-name": "Path 7219",
    d: "M139.705,149.55a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,139.705,149.55Z",
    transform: "translate(-139.705 -148.126)",
    fill: "#394f65"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11554",
    "data-name": "Group 11554",
    transform: "translate(0 3.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11551",
    "data-name": "Group 11551",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11550",
    "data-name": "Group 11550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7220",
    "data-name": "Path 7220",
    d: "M573.1,242.292a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,573.1,242.292Z",
    transform: "translate(-556.531 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7221",
    "data-name": "Path 7221",
    d: "M476.792,242.292a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,476.792,242.292Z",
    transform: "translate(-463.534 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7222",
    "data-name": "Path 7222",
    d: "M380.482,242.292a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,380.482,242.292Z",
    transform: "translate(-370.539 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7223",
    "data-name": "Path 7223",
    d: "M284.171,242.292a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,284.171,242.292Z",
    transform: "translate(-277.542 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7224",
    "data-name": "Path 7224",
    d: "M187.859,242.292a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,187.859,242.292Z",
    transform: "translate(-184.545 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7225",
    "data-name": "Path 7225",
    d: "M91.549,242.292a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,91.549,242.292Z",
    transform: "translate(-91.549 -240.868)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11553",
    "data-name": "Group 11553",
    transform: "translate(19.886 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11552",
    "data-name": "Group 11552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7226",
    "data-name": "Path 7226",
    d: "M669.413,242.292a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,669.413,242.292Z",
    transform: "translate(-669.413 -240.868)",
    fill: "#394f65"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11556",
    "data-name": "Group 11556",
    transform: "translate(1.657 6.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11555",
    "data-name": "Group 11555",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7227",
    "data-name": "Path 7227",
    d: "M621.258,335.035a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,621.258,335.035Z",
    transform: "translate(-604.686 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7228",
    "data-name": "Path 7228",
    d: "M524.947,335.035a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,524.947,335.035Z",
    transform: "translate(-511.689 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7229",
    "data-name": "Path 7229",
    d: "M428.637,335.035a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,428.637,335.035Z",
    transform: "translate(-418.694 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7230",
    "data-name": "Path 7230",
    d: "M332.326,335.035a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,332.326,335.035Z",
    transform: "translate(-325.697 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7231",
    "data-name": "Path 7231",
    d: "M236.015,335.035a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,236.015,335.035Z",
    transform: "translate(-232.701 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7232",
    "data-name": "Path 7232",
    d: "M139.705,335.035a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,139.705,335.035Z",
    transform: "translate(-139.705 -333.611)",
    fill: "#394f65"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11558",
    "data-name": "Group 11558",
    transform: "translate(1.657 12.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11557",
    "data-name": "Group 11557",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7233",
    "data-name": "Path 7233",
    d: "M621.258,521.519a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,621.258,521.519Z",
    transform: "translate(-604.686 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7234",
    "data-name": "Path 7234",
    d: "M524.947,521.519a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,524.947,521.519Z",
    transform: "translate(-511.689 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7235",
    "data-name": "Path 7235",
    d: "M428.637,521.519a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,428.637,521.519Z",
    transform: "translate(-418.694 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7236",
    "data-name": "Path 7236",
    d: "M332.326,521.519a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,332.326,521.519Z",
    transform: "translate(-325.697 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7237",
    "data-name": "Path 7237",
    d: "M236.015,521.519a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,236.015,521.519Z",
    transform: "translate(-232.701 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7238",
    "data-name": "Path 7238",
    d: "M139.705,521.519a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,139.705,521.519Z",
    transform: "translate(-139.705 -520.095)",
    fill: "#394f65"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11563",
    "data-name": "Group 11563",
    transform: "translate(0 9.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11560",
    "data-name": "Group 11560",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11559",
    "data-name": "Group 11559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7239",
    "data-name": "Path 7239",
    d: "M573.1,428.777a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,573.1,428.777Z",
    transform: "translate(-556.531 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7240",
    "data-name": "Path 7240",
    d: "M476.792,428.777a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,476.792,428.777Z",
    transform: "translate(-463.534 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7241",
    "data-name": "Path 7241",
    d: "M380.482,428.777a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,380.482,428.777Z",
    transform: "translate(-370.539 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7242",
    "data-name": "Path 7242",
    d: "M284.171,428.777a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,284.171,428.777Z",
    transform: "translate(-277.542 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7243",
    "data-name": "Path 7243",
    d: "M187.859,428.777a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,187.859,428.777Z",
    transform: "translate(-184.545 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7244",
    "data-name": "Path 7244",
    d: "M91.549,428.777a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,91.549,428.777Z",
    transform: "translate(-91.549 -427.353)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11562",
    "data-name": "Group 11562",
    transform: "translate(19.886 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11561",
    "data-name": "Group 11561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7245",
    "data-name": "Path 7245",
    d: "M669.413,428.777a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,669.413,428.777Z",
    transform: "translate(-669.413 -427.353)",
    fill: "#394f65"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11568",
    "data-name": "Group 11568",
    transform: "translate(0 15.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11565",
    "data-name": "Group 11565",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11564",
    "data-name": "Group 11564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7246",
    "data-name": "Path 7246",
    d: "M573.1,614.261a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,573.1,614.261Z",
    transform: "translate(-556.531 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7247",
    "data-name": "Path 7247",
    d: "M476.792,614.261a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,476.792,614.261Z",
    transform: "translate(-463.534 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7248",
    "data-name": "Path 7248",
    d: "M380.482,614.261a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,380.482,614.261Z",
    transform: "translate(-370.539 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7249",
    "data-name": "Path 7249",
    d: "M284.171,614.261a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,284.171,614.261Z",
    transform: "translate(-277.542 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7250",
    "data-name": "Path 7250",
    d: "M187.859,614.261a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,187.859,614.261Z",
    transform: "translate(-184.545 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7251",
    "data-name": "Path 7251",
    d: "M91.549,614.261a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,91.549,614.261Z",
    transform: "translate(-91.549 -612.837)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11567",
    "data-name": "Group 11567",
    transform: "translate(19.886 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11566",
    "data-name": "Group 11566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7252",
    "data-name": "Path 7252",
    d: "M669.413,614.261a1.424,1.424,0,1,0,1.424-1.424A1.425,1.425,0,0,0,669.413,614.261Z",
    transform: "translate(-669.413 -612.837)",
    fill: "#394f65"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrasaSubcutaneaImage);
export default __webpack_public_path__ + "static/media/grasa_subcutanea_image.51c7bab8ce826be6dd8a696d68a00e17.svg";
export { ForwardRef as ReactComponent };